import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { useEffect } from 'react';
import {
  GET_MAINTENANCE_SCHEDULES_URL,
  getMaintenanceSchedules,
} from 'src/clients';
import { useRecipientVendor } from 'src/pages/Disbursement/Bulk/useRecipientVendor';
import {
  checkUnderMaintenanceUsingSchedule,
  checkUnderMaintenanceUsingTimesAdhoc,
} from 'src/pages/Disbursement/helper';
import useSWR from 'swr';

export const useBankMaintenanceSideModal = (
  activeTab: number,
  source: string,
) => {
  useEffect(() => {
    if (activeTab === 0) {
      AnalyticsManager.instance().track(
        AnalyticsEvent.click_bank_maintenance_tab_daily,
        {
          click_from: source,
        },
      );
    } else {
      AnalyticsManager.instance().track(
        AnalyticsEvent.click_bank_maintenance_tab_adhoc,
        {
          click_from: source,
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const { data } = useSWR([GET_MAINTENANCE_SCHEDULES_URL], () =>
    getMaintenanceSchedules().then(res => res.data.data),
  );

  const orderDailyData = data?.daily
    .map(item => ({
      ...item,
      isMaintenance: checkUnderMaintenanceUsingSchedule(item.schedules),
      totalSchedule: item.schedules.length,
    }))
    .sort((a, b) => {
      if (a.isMaintenance !== b.isMaintenance) {
        return a.isMaintenance === true ? -1 : 1;
      }

      return b.totalSchedule - a.totalSchedule;
    });

  const orderAdhocData = data?.adhoc
    .map(item => ({
      ...item,
      isMaintenance: checkUnderMaintenanceUsingTimesAdhoc(item.schedules),
      totalSchedule: item.schedules.length,
    }))
    .sort((a, b) => {
      if (a.isMaintenance !== b.isMaintenance) {
        return a.isMaintenance === true ? -1 : 1;
      }

      return b.totalSchedule - a.totalSchedule;
    });

  const { getBankName } = useRecipientVendor();

  return {
    data,
    orderDailyData,
    orderAdhocData,
    getBankName,
  };
};
